import { useEffect, useMemo, useRef, useState } from "react";
import ReactDOM from 'react-dom';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { committeeActionCreators } from '../../../stores/lis-committee-store';
import { memberActionCreators } from '../../../stores/lis-members-store';
import { billActionCreators } from '../../../stores/lis-legislation-store';
import { sessionActionCreators } from '../../../stores/lis-session-store';
import { patronActionCreators } from '../../../stores/lis-patron-store';
import { voteActionCreators } from '../../../stores/lis-votes-store';
import { collectionActionCreators } from '../../../stores/lis-collection-store';
import { reportActionCreators } from "../../../stores/lis-report-store";
import { personnelActionCreators } from '../../../stores/lis-personnel-store';
import { navActionCreators } from '../../../stores/lis-nav-store';
import moment from 'moment-timezone';
import Select from 'react-select';
import * as Excel from "exceljs";
import ShareReport from './share-report'
import { zeroWidthSpace } from '../../../services/editor-manipulation';
import { sortLegislations, LinkAsButton } from "../../../services/legislation-helper-service";
import { UnsavedNotesModal } from "../../../services/modal-service";

const selectStyle = {
    control: styles => ({
        ...styles,
        borderColor: "#949494"
    }),
    dropdownIndicator: (base) => ({
        ...base,
        color: "#666666"
    }),
    clearIndicator: (base) => ({
        ...base,
        color: "#666666"
    }),
}

const CompositeView = props => {

    const [showNotes, toggleShowNotes] = useState(false);

    const [showShareForm, toggleShareForm] = useState(false);

    const [message, setMessage] = useState("");
    const [canStillWorkMessage, setCanStillWorkMessage] = useState('');

    const [gettingReport, toggleGettingReport] = useState(true);

    const [billList, setBillList] = useState([]);
    const [billData, setBillData] = useState([]);
    const [historiedData, setHistoriedData] = useState([]);

    const [gettingCollection, toggleGettingCollection] = useState(true);
    const [gettingLegislationIds, toggleGettingLegislationIds] = useState(true);
    const [gettingHistory, toggleGettingHistory] = useState(true);

    const [gettingHistoryStage, setGettingHistoryStage] = useState(0);

    const [committeesIsLoaded, toggleCommitteesIsLoaded] = useState(false);
    const [committees, setCommittees] = useState([]);

    const [collection, setCollection] = useState({});
    const [counts, setCounts] = useState({});

    const [userCreated, setUserCreated] = useState("");

    const viewRef = useRef(null);
    const printRef = useRef(null);

    const notes = useMemo(() => (collection?.WatchListLegislation ?? []).filter(s => s.Note), [collection]);

    const [saveNoteCount, setSaveNoteCount] = useState(0);
    const [updatingNote, toggleUpdatingNote] = useState(false);
    const [reportTitle, setReportTitle] = useState('');

    const sortOptions = useMemo(() => [
        { label: 'BIll Number - Ascending', value: 'BILL|ASC' },
        { label: 'Bill Number - Descending', value: 'BILL|DESC' },
        { label: 'Date - Ascending', value: 'DATE|ASC' },
        { label: 'Date - Descending', value: 'DATE|DESC' },
    ], []);

    const [selectedSort, setSelectedSort] = useState({ label: 'Bill Number - Ascending', value: 'BILL|ASC' });

    const [showUnsavedModal, toggleShowUnsavedModal] = useState(false);

    useEffect(() => {
        const reportId = props.match.params.id;
        if (reportId) {
            props.actions.getBillReportInformation('?ReportNumber=' + reportId)
                .then(() => toggleGettingReport(false))
        } else {
            setMessage('No report ID provided.');
        }
    }, []);

    useEffect(() => {
        if (!gettingReport) {
            const billReportInformation = props.report.billReportInformation;
            if (billReportInformation?.BillInformation && billReportInformation?.ReportNumber) {
                try {
                    const json = JSON.parse(window.atob(billReportInformation.BillInformation));
                    if (Array.isArray(json?.billList) && json.billList.length > 0) {
                        if (json.reportTitle) {
                            setReportTitle(json.reportTitle);
                        }
                        setBillList(json.billList);
                        setUserCreated(json.userCreated);
                        const session = json.billList[0].SessionID;
                        if (props.login.userProfile.email === json.userCreated) {
                            props.actions.getCollection("?WatchListId=" + json.selectedCollection + "&SessionID=" + session)
                                .then(() => {
                                    toggleGettingCollection(false);
                                })
                        } else {
                            toggleGettingCollection(false);
                        }
                    } else {
                        toggleGettingCollection(false);
                        setMessage("No watchlist found.");
                    }
                } catch {
                    toggleGettingCollection(false);
                    setMessage("Malformed report data.");
                    console.error("Malformed url");
                }
            } else if (props.report.billReportInformationError) {
                console.log("Request succeeded, but no report information found.");
                setMessage("This report does not exist or the link has expired.");
            } else {
                setMessage("This report does not exist or the link has expired.");
            }
        }
    }, [props.report, gettingReport]);

    useEffect(() => {
        if (!gettingCollection) {
            if (props.collection && Array.isArray(props.collection.collection) && props.collection.collection.length > 0) {
                setCollection(props.collection.collection[0]);
            } else if (props.login.userProfile.email === userCreated) {
                setMessage("No collection found.");
            }
        }
    }, [props.collection, gettingCollection]);

    useEffect(() => {
        const getReportData = () => {
            const params = {
                LegislationNumbers: [{ LegislationNumber: billList.map(bill => bill.LegislationNumber).join() }],
                SessionID: billList[0].SessionID
            };
            setCounts({
                sbCount: billList.filter(bill => bill.LegislationNumber.includes('SB')).length,
                sjCount: billList.filter(bill => bill.LegislationNumber.includes('SJ')).length,
                srCount: billList.filter(bill => bill.LegislationNumber.includes('SR')).length,
                hbCount: billList.filter(bill => bill.LegislationNumber.includes('HB')).length,
                hjCount: billList.filter(bill => bill.LegislationNumber.includes('HJ')).length,
                hrCount: billList.filter(bill => bill.LegislationNumber.includes('HR')).length,
            })
            props.actions.getBillList(params).then(() => {
                toggleGettingLegislationIds(false);
            }).catch(err => {
                console.error("Error getting bill list: ", err);
                setMessage("Error getting bill list.");
                toggleGettingLegislationIds(false);
            });
        }

        if (billList.length > 0) {
            getReportData();
            props.actions.getCommitteeList('sessionID=' + billList[0].SessionID + "&includeSubCommittees=true")
                .then(() =>
                    toggleCommitteesIsLoaded(true)
                )
        }
    }, [billList]);

    useEffect(() => {
        if (committeesIsLoaded && committees.length === 0) {
            if (Array.isArray(props.committee.committeeList) && props.committee.committeeList.length > 0) {
                setCommittees(props.committee.committeeList);
            } else {
                setCanStillWorkMessage('Unable to load committees for links.');
            }
        }
    }, [committeesIsLoaded]);

    useEffect(() => {
        // Back button safety
        const uniqueBills = [];
        props.bills.billList.forEach(b => {
            if (!uniqueBills.find(u => b.LegislationNumber === u.LegislationNumber)) {
                uniqueBills.push(b);
            }
        });
        if (!gettingLegislationIds && uniqueBills.length === billList.length) {
            if (billData.length === 0) {
                setBillData(uniqueBills);
            } else if (gettingHistoryStage > 0 && gettingHistory) {
                if (props.bills.billHistory.length === 0) {
                    setMessage('Error retrieving bill history.');
                } else {
                    const allResults = props.bills.billHistory
                    const hData = [];
                    for (let i = 0; i < billData.length; i++) {
                        const bill = { ...billData[i] };
                        let results = allResults.filter(b => b.LegislationID === bill.LegislationID);

                        let billHistory = {};
                        if (results.length > 1) {
                            billHistory.recent = results.slice(results.length - 1);
                        } else if (results.length === 1) {
                            billHistory.recent = results;
                        } else {
                            continue
                        }
                        results.forEach(historyItem => {
                            if (historyItem.CommitteeName && !historyItem.ParentCommitteeName) {
                                //Need to get the full list of committee events in composite view
                                //so we can get the latest committee event for both chambers -JGB
                                if (historyItem.Status === "In Committee" || historyItem.Status === "Reported Out-House" || historyItem.Status === "Reported Out-Senate") {
                                    if (!billHistory.Committee) {
                                        billHistory.Committee = [];
                                    }
                                    billHistory.Committee.push(historyItem);
                                }
                            }
                        });
                        let committeeEvents = {};
                        results.forEach(historyItem => {
                            if (!committeeEvents.firstSenateCommitteeEvent && historyItem.ChamberCode === "S" && historyItem.Status === "In Committee") {
                                committeeEvents.firstSenateCommitteeEvent = historyItem;
                            }
                            if (!committeeEvents.firstHouseCommitteeEvent && historyItem.ChamberCode === "H" && historyItem.Status === "In Committee") {
                                committeeEvents.firstHouseCommitteeEvent = historyItem;
                            }
                            if (historyItem.ChamberCode === "S" && (historyItem.Status === "In Committee" || historyItem.Status === "Reported Out-Senate")) {
                                committeeEvents.lastSenateCommitteeEvent = historyItem;
                            }
                            if (historyItem.ChamberCode === "H" && (historyItem.Status === "In Committee" || historyItem.Status === "Reported Out-House")) {
                                committeeEvents.lastHouseCommitteeEvent = historyItem;
                            }
                            if (historyItem.ChamberCode === "S" && historyItem.Status === "In Subcommittee") {
                                committeeEvents.lastSenateSubcommitteeEvent = historyItem;
                            }
                            if (historyItem.ChamberCode === "H" && historyItem.Status === "In Subcommittee") {
                                committeeEvents.lastHouseSubcommitteeEvent = historyItem;
                            }
                        });
                        bill.committeeEvents = committeeEvents;
                        bill.billHistory = billHistory;
                        hData.push(bill);
                    }
                    setHistoriedData(h => [...h, ...hData]);
                }
            }
        }
    }, [props.bills, gettingLegislationIds, billList, billData, gettingHistoryStage, gettingHistory]);

    useEffect(() => {
        const getBills = async () => {
            const MAX_BILL_HISTORY_CHUNK_SIZE = 125;
            const billsToFetch = [];
            let billChunks = [];
            for (let i = 0; i < billData.length; i++) {
                billChunks.push(billData[i].LegislationID);
                if (billChunks.length >= MAX_BILL_HISTORY_CHUNK_SIZE) {
                    billsToFetch.push(billChunks);
                    billChunks = [];
                }
            }
            if (billChunks.length > 0) {
                billsToFetch.push(billChunks);
            }
            for (let i = 0; i < billsToFetch.length; i++) {
                if (billsToFetch[i].length > 0) {
                    const params = '?legislationIDs=' + billsToFetch[i].join('&legislationIDs=');
                    await props.actions.getBillHistoryByBillID(params).then(() => {
                        if (gettingHistoryStage === 0) {
                            setGettingHistoryStage(1);
                        }
                        if (i === billsToFetch.length - 1) {
                            toggleGettingHistory(false);
                        }
                    })
                }
            }
        }
        getBills();
    }, [billData]);

    useEffect(() => {
        if (saveNoteCount > 0) {
            if (props.collection.collectionSave[0]) {
                setCollection(structuredClone(props.collection.collectionSave[0]));
                props.actions.makeToast([{ message: "Save Successful", type: "success" }]);
            } else {
                setMessage("Error saving note.");
                props.actions.makeToast([{ message: "Save Failure", type: "error" }]);
            }
            toggleUpdatingNote(false);
        }
    }, [saveNoteCount]);

    const generateWorkbook = () => {
        const workbook = new Excel.Workbook();
        workbook.addWorksheet('Bill Report');
        const sheet = workbook.worksheets[0];
        const headers = [
            {
                header: 'Bill',
                key: 'bill',
            },
            {
                header: 'Chief Patron',
                key: 'chiefPatron',
            },
            {
                header: 'Catchline',
                key: 'catchline',
            },
            {
                header: 'Committee (H)',
                key: 'houseCommittee',
            },
            {
                header: 'Committee (S)',
                key: 'senateCommittee',
            },
            {
                header: 'Last Action',
                key: 'lastAction'
            },
            {
                header: 'Last Action Date',
                key: 'lastActionDate',
            }
        ];
        // Only include notes if they are being shown. Last one is the count
        const els = Array.from(document.getElementsByClassName('composite-view-wrapper'));
        els.length--;
        const visibleCount = els.length - els.filter(el => el.classList.contains('notes-hidden')).length;
        const showNotesColumn = showNotes || visibleCount > 0;
        if (showNotesColumn) {
            headers.push({
                header: 'Note',
                key: 'note',
            });
        }
        sheet.columns = headers;
        const rows = historiedData.map((bill, i) => {
            const foundChiefPatron = bill.Patrons.find(x => x.PatronTypeID === 1);
            let chiefPatron = null
            if (foundChiefPatron) {
                chiefPatron = {
                    text: foundChiefPatron.PatronDisplayName ?? '',
                    hyperlink: `${window.location.origin}/session-details/${bill.SessionCode}/member-information/${foundChiefPatron.MemberNumber}/member-details`,
                    tooltip: `${window.location.origin}/session-details/${bill.SessionCode}/member-information/${foundChiefPatron.MemberNumber}/member-details`
                }
            }
            const foundHouseCommittee = bill.billHistory?.Committee?.find(x => x.ChamberCode === "H") ? bill.billHistory.Committee.sort((a, b) => moment(a.EventDate).isBefore(b.EventDate) ? 1 : -1).find(x => x.ChamberCode === "H").ParentCommitteeName ?? bill.billHistory.Committee.sort((a, b) => moment(a.EventDate).isBefore(b.EventDate) ? 1 : -1).find(x => x.ChamberCode === "H") : {};
            let houseCommittee = null;
            if (foundHouseCommittee.CommitteeName) {
                const linkJSX = generateCompositeCommitteeLink('H', bill);
                houseCommittee = {
                    text: foundHouseCommittee.CommitteeName,
                    hyperlink: window.location.origin + linkJSX.props.to,
                    tooltip: window.location.origin + linkJSX.props.to
                }
            }
            const foundSenateCommittee = bill.billHistory?.Committee?.find(x => x.ChamberCode === "S") ? bill.billHistory.Committee.sort((a, b) => moment(a.EventDate).isBefore(b.EventDate) ? 1 : -1).find(x => x.ChamberCode === "S").ParentCommitteeName ?? bill.billHistory.Committee.sort((a, b) => moment(a.EventDate).isBefore(b.EventDate) ? 1 : -1).find(x => x.ChamberCode === "S") : {};
            let senateCommittee = null;
            if (foundSenateCommittee.CommitteeName) {
                const linkJSX = generateCompositeCommitteeLink('S', bill);
                senateCommittee = {
                    text: foundSenateCommittee.CommitteeName,
                    hyperlink: window.location.origin + linkJSX.props.to,
                    tooltip: window.location.origin + linkJSX.props.to
                }
            }
            let lastAction = (bill.billHistory.recent[0].ChamberCode ? "(" + bill.billHistory.recent[0].ChamberCode + ") " : "") + bill.billHistory.recent[0].Description;
            const lastActionLink = generateActionLinkIfVote(bill);
            if (Array.isArray(lastActionLink.props.children) && lastActionLink.props.children.length > 1) {
                lastAction = {
                    text: (bill.billHistory.recent[0].ChamberCode ? "(" + bill.billHistory.recent[0].ChamberCode + ") " : "") + bill.billHistory.recent[0].Description,
                    hyperlink: lastActionLink.props.children[1].props.href,
                    tooltip: lastActionLink.props.children[1].props.href
                }
            }
            const lastActionDate = bill.billHistory ? moment(bill.billHistory.recent[0].EventDate).tz('America/New_York').format("MM/DD/YYYY") : "";
            const note = !els[i].classList.contains('notes-hidden') ? (notes.find(n => n.LegislationNumber === bill.LegislationNumber)?.Note || null) : null;
            // It does not like having text: '' when its an empty cell and could have a hyperlink. Just make it null.
            return {
                bill: {
                    text: bill.LegislationNumber,
                    hyperlink: `${window.location.origin}/bill-details/${bill.SessionCode}/${bill.LegislationNumber}`,
                    tooltip: `${window.location.origin}/bill-details/${bill.SessionCode}/${bill.LegislationNumber}`
                },
                chiefPatron: chiefPatron?.hyperlink ? chiefPatron : null,
                catchline: bill.Description.trim(),
                houseCommittee,
                senateCommittee,
                lastAction,
                lastActionDate,
                note
            }
        })
        sheet.addRows(rows);
        return workbook;
    }

    const generateCSV = async (e) => {
        e?.preventDefault();
        const workbook = generateWorkbook();
        const options = {
            map(value, index) {
                if (value?.hyperlink) {
                    return `=HYPERLINK("${value.hyperlink}","${value.text}")`;
                }
                return value.text ?? value;
            }
        }
        await workbook.csv.writeBuffer(options).then((buffer) => {
            const a = document.createElement('a');
            const data = new Blob([buffer], { type: "data:text/csv;charset=utf-8," });
            const url = window.URL.createObjectURL(data);
            a.href = url;
            a.download = `${props.collection.collection[0]?.Name ?? 'Search Results'} ${moment().tz('America/New_York').format("MM_DD_YYYY HH mm")}.csv`
            a.click();
            setTimeout(() => {
                a.remove();
                window.URL.revokeObjectURL(url);
            });
        }).catch((error) => {
            console.error('Error writing excel file:', error);
        });
    }

    const generateXLSX = async (e) => {
        e?.preventDefault();
        const workbook = generateWorkbook();
        // Set the notes to wrap text, otherwise \n don't appear properly
        // Gotta love accessing private properties
        // This wasn't working when I tried doing it on the header definition
        workbook.worksheets.forEach(sheet => {
            sheet._columns.forEach(column => {
                if (column._key === 'note') {
                    column.alignment = { wrapText: true };
                } else {
                    column.alignment = { vertical: 'top' }
                }
            })
        });
        workbook.worksheets.forEach(sheet => {
            sheet.eachRow(row => {
                row.eachCell(cell => {
                    if (!!cell?._value?.model?.hyperlink) {
                        let linkColor = '2875B8'; //a11y later
                        cell.font = {
                            color: {
                                argb: `FF${linkColor}`
                            },
                            underline: true
                        };
                    }
                });
            });
        });
        await workbook.xlsx.writeBuffer().then((buffer) => {
            const a = document.createElement('a');
            const data = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
            const url = window.URL.createObjectURL(data);
            a.href = url;
            a.download = `${props.collection.collection[0]?.Name ?? 'Search Results'} ${moment().tz('America/New_York').format("MM_DD_YYYY HH mm")}.xlsx`
            a.click();
            setTimeout(() => {
                a.remove();
                window.URL.revokeObjectURL(url);
            });
        }).catch((error) => {
            console.error('Error writing excel file:', error);
        });
    }

    const makeHtml = () => {
        const htmlRefNode = ReactDOM.findDOMNode(viewRef.current).cloneNode(true);
        let x = htmlRefNode.querySelectorAll('a');
        x.forEach(el => {
            el.setAttribute('href', el.href);
        })
        let breaks = htmlRefNode.querySelectorAll('hr');
        [...breaks].forEach(b => {
            b.parentNode.removeChild(b);
        });
        const textAreas = htmlRefNode.querySelectorAll('textarea');
        textAreas.forEach(textArea => {
            const newDiv = document.createElement('div');
            newDiv.textContent = textArea.value;
            textArea.parentNode.replaceChild(newDiv, textArea);
        });
        const buttons = htmlRefNode.querySelectorAll('button');
        buttons.forEach(button => {
            button.parentNode.removeChild(button);
        });
        Array.from(htmlRefNode.querySelectorAll('.composite-view-committees'))
            .flatMap(div => Array.from(div.querySelectorAll('a')))
            .forEach(link => {
                link.style.display = 'block';
                link.style.width = 'fit-content';
            });
        htmlRefNode.innerHTML = htmlRefNode.innerHTML.replaceAll('‑', '-');
        const fileName = `${props.collection.collection[0]?.Name ?? 'Search Results'} ${moment().tz('America/New_York').format("MM_DD_YYYY HH mm")}.html`
        saveAs(new Blob([htmlRefNode.innerHTML], { type: "text/html" }), fileName);
    }

    const makePrintout = () => {
        const currentView = viewRef.current;
        if (!currentView) {
            return;
        }
        let printWindow = printRef.current;
        const pageStyles = document.querySelectorAll("style, link[rel='stylesheet']");
        pageStyles.forEach(el => {
            printWindow.contentDocument.head.appendChild(el.cloneNode(true));
        });
        // Copilot autocomplete kept adding brackets randomly. No more single line
        printWindow.contentDocument.head.appendChild(document.createElement('style')).textContent = `
        .composite-view-wrapper .composite-view-data,
        .composite-view-header {
            grid-template-columns: 1fr 1fr 1fr .35fr;
            height: fit-content;
        }

        .composite-view-data.notes-hidden,
        .composite-view-header {
            border-bottom: 1px solid #ccc;
        }

        .composite-view-heading {
            border-bottom: 1px solid #ccc;
        }

        .composite-view-heading>*:not(:first-child) {
            display: none;
        }

        .composite-view-note-panel {
            grid-template-columns: 1fr !important;

            button {
                display: none;
            }
        }

        .composite-view-note-panel.editing {
            min-height: 100% !important;
        }

        .composite-view-data>a:first-child {
            display: none;
        }

        .composite-view-header>div:first-child {
            display: none;
        }

        .composite-view-wrapper:last-of-type .composite-view-data {
            grid-template-columns: 1fr;
        }

        .composite-view-wrapper,
        .composite-view-data,
        .composite-view-header {
            break-inside: avoid;
            page-break-inside: avoid;
        }
        `;
        const reportDataNode = ReactDOM.findDOMNode(currentView);
        const contentData = document.getElementsByClassName('composite-view-heading')[0].outerHTML + reportDataNode.innerHTML;
        printWindow.contentDocument.body.innerHTML = contentData;
        const icons = Array.from(printWindow.contentDocument.body.getElementsByClassName('bubble'))
            .concat(Array.from(printWindow.contentDocument.body.getElementsByClassName('bubble-hollow')));
        icons.forEach(i => i.parentElement.remove());
        // Textareas don't play well with printing all of the text
        const textAreas = printWindow.contentDocument.querySelectorAll('textarea');
        textAreas.forEach(textArea => {
            const newDiv = document.createElement('div');
            newDiv.style.whiteSpace = 'break-spaces';
            newDiv.textContent = textArea.value;
            textArea.parentNode.replaceChild(newDiv, textArea);
        });
        printWindow.focus();
        // timeout is because some browsers do not set the content of the document in time. Since there is no way to check when it is actually finished this 10 millisecond timeout should do the trick.
        setTimeout(() => printWindow.contentWindow.print(), 10);
    }

    const generateActionLinkIfVote = bill => {
        if (!bill.billHistory) {
            return <div />
        }
        const actionStr = (bill.billHistory.recent[0].ChamberCode ? "(" + bill.billHistory.recent[0].ChamberCode + ") " : "") + bill.billHistory.recent[0].Description?.replaceAll('-', '\u2011');
        if (!!bill.billHistory.recent[0].VoteNumber) {
            const e = actionStr.lastIndexOf('(')
            return <div>{actionStr.substring(0, e)}
                <a href={`${window.location.origin}/vote-details/${bill.LegislationNumber}/${bill.SessionCode}/${bill.billHistory.recent[0].VoteNumber}`}>{actionStr.substring(e)}</a>
            </div>
        } else {
            return <div>{actionStr}</div>
        }
    }

    const generateCompositeCommitteeLink = (chamber, bill) => {
        const foundCommittee = bill.billHistory.Committee.find(x => x.ChamberCode === chamber);
        if (!foundCommittee) {
            return <></>;
        }
        const committee = bill.billHistory.Committee.sort((a, b) => moment(a.EventDate).isBefore(b.EventDate) ? 1 : -1).find(x => x.ChamberCode === chamber) ?? bill.billHistory.Committee.sort((a, b) => moment(a.EventDate).isBefore(b.EventDate) ? 1 : -1).find(x => x.ChamberCode === "H");
        const committeeName = committee.ParentCommitteeName ?? committee.CommitteeName;
        const committeeNumber = committees.find(c => c.Name === committeeName)?.CommitteeNumber
        const text = `(${chamber}) ${committee.ParentCommitteeName ?? committee.CommitteeName}`;
        if (committeeNumber) {
            const href = `/session-details/${bill.SessionCode}/committee-information/${committeeNumber}/committee-details`;
            return <Link to={href}>
                {text}
            </Link>
        } else {
            return <span>{text}</span>
        }
    }

    const generatePatronLink = (bill) => {
        const chiefPatron = bill.Patrons.find(x => x.PatronTypeID === 1);
        if (!chiefPatron) {
            return null;
        }
        return <>
            <Link to={`/session-details/${bill.SessionCode}/member-information/${chiefPatron.MemberNumber}/member-details`}>{chiefPatron.PatronDisplayName}</Link>
            <> - </>
        </>
    }

    const updateNote = (note, LegislationNumber, callback) => {
        toggleUpdatingNote(true);
        const updatedCollection = { ...collection };
        const watchListLegislation = updatedCollection.WatchListLegislation.map(item => {
            if (item.LegislationNumber === LegislationNumber) {
                return { ...item, Note: note };
            }
            return item;
        });
        updatedCollection.WatchListLegislation = watchListLegislation;
        props.actions.saveCollections({ WatchLists: [updatedCollection] })
            .then(() => {
                callback()
                setSaveNoteCount(c => c + 1)
            })
    }

    const isLoading = gettingHistory || gettingCollection || gettingLegislationIds || historiedData.length !== billData.length;
    const canShowNotes = props.login.userProfile.email === userCreated;

    const handleToggleShowNotes = (inc) => {
        if (inc) {
            toggleShowNotes(true);
        } else {
            const notesToSave = getChangedNotes();
            if (notesToSave.length > 0) {
                toggleShowUnsavedModal(true);
            } else {
                toggleShowNotes(false);
            }
        }
    }

    const getChangedNotes = () => {
        const notesToSave = [];
        const theHoldersOfNotesThatNeedToBeSaved = document.getElementsByClassName('composite-view-wrapper');
        Array.from(theHoldersOfNotesThatNeedToBeSaved).forEach(t => {
            const theAsterisk = t.getElementsByClassName('red');
            if (theAsterisk.length > 0) {
                const noteArea = t.getElementsByTagName('textarea');
                const links = t.getElementsByTagName('a');
                if (noteArea.length > 0 && links.length > 0 && Array.from(links).at(1)) { /// TODO: may need to fix down the road if the bubble becomes button
                    notesToSave.push({
                        LegislationNumber: links[1].textContent,
                        note: noteArea[0].textContent ?? undefined
                    });
                }
            }
        });
        return notesToSave;
    }

    const saveChanges = () => {
        const notesToSave = getChangedNotes();
        toggleUpdatingNote(true);
        const updatedCollection = { ...collection };
        const watchListLegislation = updatedCollection.WatchListLegislation.map(item => {
            const newNote = notesToSave.find(s => s.LegislationNumber === item.LegislationNumber);
            if (newNote) {
                return { ...item, Note: newNote.note };
            }
            return item;
        });
        updatedCollection.WatchListLegislation = watchListLegislation;
        props.actions.saveCollections({ WatchLists: [updatedCollection] })
            .then(() => {
                setSaveNoteCount(c => c + 1);
                toggleUpdatingNote(false);
                if (showNotes) {
                    handleToggleShowNotes(false);
                } else {
                    Array.from(document.getElementsByClassName('icon delete')).forEach(b => b.click());
                }
                toggleShowUnsavedModal(false)
            });
    }

    const ignoreChanges = () => {
        Array.from(document.getElementsByClassName('icon delete')).forEach(b => b.click());
        toggleShowUnsavedModal(false)
        toggleShowNotes(false);
    }

    return (
        <div>
            {showUnsavedModal &&
                <UnsavedNotesModal saveChanges={saveChanges} ignoreChanges={ignoreChanges} closeModal={() => toggleShowUnsavedModal(false)} disabled={isLoading} />
            }
            {message ? <div className="error-message">{message}</div> :
                <>
                    <div className="flex-row">
                        <div className={`composite-view-heading ` + (canShowNotes ? '' : 'not-shareable')}>
                            <h2>{gettingCollection ? <span className="small-spinner" /> : reportTitle ?? zeroWidthSpace}</h2>
                            {canShowNotes && <button disabled={isLoading} type="button" className="button" onClick={() => handleToggleShowNotes(!showNotes)}>{(showNotes ? "Close" : "Edit") + " Notes +/-"}</button>}
                            {canShowNotes && <button disabled={isLoading} onClick={() => toggleShareForm(s => !s)} type="button" className="button">Share <span className='icon share' /></button>}
                            <button disabled={isLoading} type="button" className="button just-icon" aria-label="print" title="print" onClick={makePrintout}><span className={`icon print`} /></button>
                            <button disabled={isLoading} type="button" className="button just-icon" aria-label='download xlsx' title="download xlsx" onClick={generateXLSX}><span className='icon csv' /></button>
                            <button disabled={isLoading} type="button" className="button just-icon" aria-label='download html' title='download html' onClick={makeHtml}><span className='icon paper' /></button>
                            <button disabled={isLoading} type="button" className="button" title='download csv' aria-label='download csv' onClick={generateCSV}>CSV</button>
                            <Select
                                aria-label="Sort by selector"
                                id="cv-bill-sort"
                                options={sortOptions}
                                placeholder=""
                                onChange={(opt) => setSelectedSort(opt)}
                                value={selectedSort}
                                classNamePrefix='composite-view-sorting-options'
                                disabled={isLoading}
                                styles={selectStyle}
                            />
                        </div>
                    </div>
                    {canStillWorkMessage && <div style={{ color: '#dc3545' }}>{canStillWorkMessage}</div>}
                    {isLoading ? <span className="small-spinner" /> :
                        <div className="report-container" ref={viewRef} style={{ margin: 0 }}>
                            <div className={'composite-view-header ' + (canShowNotes ? '' : 'not-shareable')}>
                                <div />
                                <div>Bill</div>
                                <div>Committee</div>
                                <div>Last Action</div>
                                <div>Date</div>
                            </div>
                            {historiedData.toSorted((a, b) => {
                                if (selectedSort.value === 'BILL|ASC') {
                                    return sortLegislations(a, b);
                                } else if (selectedSort.value === 'BILL|DESC') {
                                    return sortLegislations(b, a);
                                } else if (selectedSort.value === 'DATE|ASC') {
                                    const dateA = a.billHistory?.recent[0]?.EventDate ? moment(a.billHistory.recent[0].EventDate) : moment();
                                    const dateB = b.billHistory?.recent[0]?.EventDate ? moment(b.billHistory.recent[0].EventDate) : moment();
                                    return dateA.isBefore(dateB) ? -1 : 1;
                                } else {
                                    const dateA = a.billHistory?.recent[0]?.EventDate ? moment(a.billHistory.recent[0].EventDate) : moment();
                                    const dateB = b.billHistory?.recent[0]?.EventDate ? moment(b.billHistory.recent[0].EventDate) : moment();
                                    return dateA.isAfter(dateB) ? -1 : 1;
                                }
                            }).map((bill, i) => {
                                const note = notes.find(n => n.LegislationNumber === bill.LegislationNumber);
                                return <BillPanel note={note} bill={bill} generateCompositeCommitteeLink={generateCompositeCommitteeLink} generateActionLinkIfVote={generateActionLinkIfVote}
                                    generatePatronLink={generatePatronLink} committeesIsLoaded={committeesIsLoaded}
                                    updateNote={updateNote} key={bill.LegislationNumber} showNotes={showNotes} canShowNotes={canShowNotes} updatingNote={updatingNote}
                                />
                            })}
                            <div className="composite-view-wrapper notes-hidden no-border">
                                <div className={"composite-view-data " + (canShowNotes ? '' : ' not-shareable')}>
                                    <div />
                                    <span className="composite-view-counts">{`Counts - HB: ${counts.hbCount}, HJ: ${counts.hjCount}, HR: ${counts.hrCount}, SB: ${counts.sbCount}, SJ: ${counts.sjCount}, SR: ${counts.srCount}`}</span>
                                </div>
                            </div>
                        </div>}
                    {showShareForm && <ShareReport
                        toggleShareForm={() => toggleShareForm(false)}
                        emailSubject={props.collection.collection[0]?.Name}
                        source={'composite-view'}
                    />}
                    <iframe aria-hidden="true" ref={printRef} width="0" height="0" frameBorder="0" src="about:blank"></iframe>
                </>
            }
        </div>)
}


export default connect(
    (state) => {
        const { bills, session, members, committee, patrons, nav, login, votes, collection, report, personnel } = state;
        return {
            bills,
            session,
            members,
            committee,
            patrons,
            nav,
            login,
            votes,
            collection,
            report,
            personnel
        }
    },
    (dispatch) => {
        return {
            actions: bindActionCreators(Object.assign({}, committeeActionCreators, billActionCreators, navActionCreators, sessionActionCreators, memberActionCreators, patronActionCreators, voteActionCreators, collectionActionCreators, reportActionCreators, personnelActionCreators), dispatch)
        }
    }
)(CompositeView);

const BillPanel = props => {

    const [isEditing, toggleEditing] = useState(false);
    const [noteText, setNoteText] = useState(props.note?.Note || '');

    const bill = useMemo(() => props.bill, [props.bill]);

    useEffect(() => {
        if (props.showNotes) {
            toggleEditing(true);
        } else if (!props.showNotes) {
            toggleEditing(false);
        }

    }, [props.showNotes]);

    useEffect(() => {
        if (props.note) {
            setNoteText(props.note.Note || '');
        }
    }, [props.note?.Note]);

    return (
        <div className={'composite-view-wrapper ' + (!isEditing && "notes-hidden")} >
            <div className={'composite-view-data' + (props.canShowNotes ? '' : ' not-shareable')}>
                {props.canShowNotes ?
                    <div>
                        <LinkAsButton onClick={() => toggleEditing(e => !e)} className={`icon bubble${!props.note ? "-hollow" : ''}`} text={props.note ? "Edit notes" : "Add notes"} />
                        {((!props.note && !!noteText) || (!!props.note?.Note && props.note.Note !== noteText)) && <div className="red">*</div>}
                    </div>
                    :
                    <div />
                }
                <div>
                    <Link to={"/bill-details/" + bill.SessionCode + "/" + bill.LegislationNumber}>{bill.LegislationNumber}</Link>
                    <> </> - {props.generatePatronLink(bill)}{bill.Description}</div>
                {bill.billHistory && bill.billHistory.Committee
                    ? <div className='composite-view-committees'>{
                        !props.committeesIsLoaded ?
                            <span className="small-spinner" /> : <>
                                {props.generateCompositeCommitteeLink('H', bill)}
                                {props.generateCompositeCommitteeLink('S', bill)}
                            </>}</div>
                    : <div className='composite-view-committees'>
                        <div />
                        <div />
                    </div>
                }
                {props.generateActionLinkIfVote(bill)}
                <div>
                    {bill.billHistory
                        ? moment(bill.billHistory.recent[0].EventDate).tz('America/New_York').format("MM/DD/YY")
                        : ""}
                </div>
            </div>
            {isEditing &&
                <div className={`composite-view-note-panel ${isEditing ? 'editing' : ''}`}>
                    <textarea aria-label={`Note for ${bill.LegislationNumber}`} value={noteText} onChange={(e) => setNoteText(e.target.value)} placeholder={`${bill.LegislationNumber} Note`} />
                    <button className='icon save' aria-label='save' type='button' onClick={() => props.updateNote(noteText, bill.LegislationNumber, () => toggleEditing(false))} disabled={props.updatingNote}></button>
                    <button className='icon delete' aria-label='cancel' type='button' onClick={() => { setNoteText(props.note?.Note || ''); toggleEditing(false) }} disabled={props.updatingNote}></button>
                </div>
            }
        </div>
    )
}
